import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomPhoneSvg = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M8.75 1.25H6.875C6.37772 1.25 5.90081 1.44754 5.54917 1.79917C5.19754 2.15081 5 2.62772 5 3.125V16.875C5 17.3723 5.19754 17.8492 5.54917 18.2008C5.90081 18.5525 6.37772 18.75 6.875 18.75H13.125C13.6223 18.75 14.0992 18.5525 14.4508 18.2008C14.8025 17.8492 15 17.3723 15 16.875V3.125C15 2.62772 14.8025 2.15081 14.4508 1.79917C14.0992 1.44754 13.6223 1.25 13.125 1.25H11.25M8.75 1.25V2.5H11.25V1.25M8.75 1.25H11.25M8.75 16.875H11.25"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default CustomPhoneSvg;
